/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Namerequired1Inputs */

const he_profile_errors_namerequired1 = /** @type {(inputs: Profile_Errors_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם נדרש`)
};

const en_profile_errors_namerequired1 = /** @type {(inputs: Profile_Errors_Namerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required`)
};

/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Profile_Errors_Namerequired1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_errors_namerequired1 = /** @type {((inputs?: Profile_Errors_Namerequired1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Namerequired1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_errors_namerequired1(inputs)
	return en_profile_errors_namerequired1(inputs)
});
export { profile_errors_namerequired1 as "profile_errors_nameRequired" }